/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ECWOrderMessage = {
    readonly id?: number;
    status?: ECWOrderMessage.status;
    duplicate_case?: number | null;
    readonly created_at?: string;
}

export namespace ECWOrderMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
